import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { ProductRoute, ProductPathName } from '@/modules/ta/product/product.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${ProductRoute.PRODUCTS}`,
      name: ProductPathName.PRODUCTS,
      component: () => import(/* webpackChunkName: "products-page" */ './pages/ProductsPage.vue'),
    },
  ],
  Module.PRODUCT
);
